import { useRef, useState } from 'react'
import { useOutsideAlerter } from './form/SelectField'
import ChevronUpDownIcon from './icons/ChevronUpDownIcon'
import CheckIcon from './icons/CheckIcon'

export default function MobileStudentTabs({tabs, doSelect}) {
    const [selected, setSelected] = useState(tabs[0])
    const [optionsOpen, setOptionsOpen] = useState(false)

    const selectTab = (tabIndex) => {
        setSelected(tabs[tabIndex])
        doSelect(tabIndex)
        setOptionsOpen(false)
    }

    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef, () => setOptionsOpen(false));

    return (
        <div ref={wrapperRef} className="w-full relative">
            <button onClick={()=>{setOptionsOpen(!optionsOpen)}} className={`p-[10px] rounded w-full flex items-center justify-between text-left border  text-sm text-gray-600 font-medium font-space-grotesk ${optionsOpen ? 'bg-gray-100 border-gray-100' : 'bg-gray-50 border-gray-200'}`}>
                {selected.label}
                <ChevronUpDownIcon className={`w-4 h-4`} />
            </button>

            {optionsOpen && <div className='w-full absolute p-[10px] top-[50px] left-0 bg-white z-50 border rounded shadow-lg shadow-black/5'>
                {tabs.map((tab, tabIndex) =>(<button onClick={()=>{selectTab(tabIndex)}} key={tabIndex} className='w-full p-[10px] text-sm text-left font-medium text-[13px] hover:bg-gray-50 flex items-center justify-between'>
                    {tab.label}
                    {selected.value === tab.value && <CheckIcon className={`w-4 h-4`} />}
                </button>))}
            </div>}
        </div>
    )
}